import { useEffect, useState } from 'react';
import type { DirectorMessagePayload } from '@efira/protocol';

/**
 * Сообщение ведущего в кадре.
 *
 * ВТОРОЕ И ПОСЛЕДНЕЕ ИСКЛЮЧЕНИЕ из правила молчаливого overlay - после
 * сообщения об исчерпании квоты. Оба объединяет одно: текст показывает
 * ПЛАТФОРМА, а не игра, и показывает его зрителю по решению человека, а не по
 * ходу мира.
 *
 * Игра о сообщении не знает: она рисует свою сцену, а этот блок живёт поверх
 * неё. Иначе все десять игр были бы обязаны уметь показывать чужой текст - и
 * каждая делала бы это по-своему.
 *
 * СНИМАЕТСЯ САМО. Длительность приходит вместе с текстом: ведущий решает в
 * момент отправки, держать поздравление три секунды или полминуты. Оставить
 * снятие на ведущего значило бы получить текст, забытый в кадре на весь эфир.
 *
 * СТОИТ В ВЕРХНЕЙ ТРЕТИ. Низ и правый край кадра закрывает интерфейс TikTok
 * (охранные зоны, docs/ARCHITECTURE.md): сообщение, ради которого ведущий
 * прервал игру, обязано быть видно, а не оказаться под панелью подарков.
 */
export function DirectorMessage({ message }: { message: DirectorMessagePayload | null }) {
  /**
   * Скрытое сообщение помнится ПО ИДЕНТИФИКАТОРУ, а не копией.
   *
   * Иначе пришлось бы класть пришедшее сообщение в своё состояние прямо в
   * эффекте - каскад перерисовок, который правило проекта запрещает. Здесь
   * состояние хранит только «какое уже отыграло», а показывается всегда то,
   * что пришло сверху.
   */
  const [expired, setExpired] = useState<string | null>(null);

  useEffect(() => {
    if (message === null) {
      return;
    }

    const id = window.setTimeout(() => {
      setExpired(message.id);
    }, message.seconds * 1000);

    return () => {
      window.clearTimeout(id);
    };
  }, [message]);

  const shown = message !== null && message.id !== expired ? message : null;

  if (shown === null) {
    return null;
  }

  return (
    <div className="lc-director" data-director-message={shown.id} role="status" aria-live="polite">
      {shown.text}
    </div>
  );
}
